var patient_access = ( function( $ ) {

	var $faqs;

	var toggling_faq_group = false;

	var _init = function() {
		_init_faqs();
	};

	var _init_faqs = function() {
		$faqs = $( '#patient-access-faqs' );

		if ( $faqs.length > 0 ) {
			var $faq_group_toggle = $faqs.find( '.faq-group-toggle' );

			$faq_group_toggle.on( 'click', function( e ) {
				e.preventDefault();

				if ( toggling_faq_group ) {
					return;
				}

				$faq_group_toggle.removeClass( 'active' );

				var $toggle     = $( this );
				var group_id    = $toggle.data( 'faq-index' );
				var $faq_groups = $faqs.find( '.faq-group' );
				var none_shown  = $faqs.find( '.faq-group:visible' ).length === 0;

				$faq_groups.each( function() {
					var $this        = $( this );
					var $this_toggle = $faqs.find( '.faq-group-toggle[data-faq-index=' + $this.data( 'faq-index' ) + ']' );

					if ( $this.data( 'faq-index' ) === group_id ) {
						if ( $this.is( ':visible' ) ) {
							_slide_faq_group( $this_toggle, $this, true, true );
						} else {
							$toggle.addClass( 'active' );
							setTimeout( function() {
								_slide_faq_group( $this_toggle, $this, false, true );
							}, none_shown ? 0 : 500 );
						}
					} else {
						_slide_faq_group( $this_toggle, $this, true, false );
					}
				} );
			} );
		}
	};

	var _slide_faq_group = function( $toggle, $faq_group, hide, set_done_after ) {
		var $show_hide_text    = $toggle.children( '.show-hide-faqs' );
		var $faq_group_toggles = $faqs.find( '.faq-group-toggles' ).first();

		if ( hide ) {
			$show_hide_text.text( $faq_group_toggles.data( 'show' ) );
			$faq_group.slideUp( 400, set_done_after ? _done_toggling_faq_group : null );
		} else {
			$show_hide_text.text( $faq_group_toggles.data( 'hide' ) );
			$faq_group.slideDown( 400, set_done_after ? _done_toggling_faq_group : null );

			if ( $( window ).width() < 481 ) {
				$( 'html, body' ).animate( {
					scrollTop: ( $faq_group.offset().top - 40 )
				}, 500 );
			}
		}
	};

	var _done_toggling_faq_group = function() {
		toggling_faq_group = false;
	};

	if ( $( '.page-template-patient-access' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = patient_access;